/** Enrichment contract v1. Product commerce fields are deliberately excluded. */
export const ENRICHMENT_FIELDS = {
	type: {
		group: "Core",
		values: ["Dress", "Kurta", "Shirt", "Top", "Trousers", "Skirt", "Saree", "Co-ord", "Jacket", "Bag", "Jewellery"],
	},
	fabric: {
		group: "Core",
		values: ["Cotton", "Linen", "Silk", "Viscose", "Wool", "Polyester", "Denim", "Chiffon", "Organza"],
	},
	colour: {
		group: "Core",
		values: ["Black", "White", "Blue", "Green", "Red", "Pink", "Yellow", "Beige", "Brown", "Purple", "Multicolour"],
	},
	pattern: {
		group: "Core",
		values: ["Solid", "Floral", "Striped", "Checked", "Abstract", "Geometric", "Polka dot"],
	},
	silhouette: {
		group: "Core",
		values: ["A-line", "Straight", "Flared", "Wrap", "Empire", "Bodycon"],
	},
	fit: {
		group: "Core",
		values: ["Relaxed", "Regular", "Slim", "Oversized", "Fitted"],
	},
	length: {
		group: "Core",
		values: ["Mini", "Midi", "Maxi", "Cropped", "Full length", "Knee length"],
	},
	neckline: {
		group: "Details",
		values: ["V-neck", "Round", "Square", "Collared", "Boat neck", "Halter"],
	},
	sleeve: {
		group: "Details",
		values: ["Sleeveless", "Short", "Three-quarter", "Long", "Puff"],
	},
	pockets: { group: "Details", values: ["With pockets", "No pockets"] },
	lining: { group: "Details", values: ["Lined", "Unlined", "Partially lined"] },
	closure: {
		group: "Details",
		values: ["Buttons", "Zip", "Tie", "Slip-on", "Hook"],
	},
	stretch: {
		group: "Details",
		values: ["Non-stretch", "Some stretch", "Stretch"],
	},
	care: {
		group: "Details",
		values: ["Hand wash", "Machine wash", "Dry clean"],
	},
	craft: {
		group: "Discovery",
		values: ["Handwoven", "Block print", "Embroidery", "Tie-dye", "Ikat", "Batik"],
	},
	surface: {
		group: "Discovery",
		values: ["Pleats", "Ruffles", "Sequins", "Beading", "Applique", "Smocking"],
	},
	occasion: {
		group: "Discovery",
		values: ["Everyday", "Work", "Holiday", "Party", "Festive", "Wedding"],
	},
	aesthetic: {
		group: "Discovery",
		values: ["Minimal", "Bohemian", "Classic", "Romantic", "Contemporary", "Playful"],
	},
	for: { group: "Discovery", values: ["Women", "Men", "Kids", "Unisex"] },
	season: {
		group: "Discovery",
		values: ["Summer", "Winter", "Monsoon", "All season"],
	},
} as const
export type EnrichmentField = keyof typeof ENRICHMENT_FIELDS
export type FieldReview = {
	values: string[]
	state: "suggested" | "reviewed" | "unknown" | "not_applicable"
	evidence: string
}
export type EnrichmentFields = Partial<Record<EnrichmentField, FieldReview>>
export type EnrichmentIdentity = {
	organizationId: string
	collection: string
	productId: string
}
export type EnrichmentRecord = {
	schemaVersion: 1
	identity: EnrichmentIdentity
	revision: number
	sourceHash: string
	fields: EnrichmentFields
	updatedAt?: string
	updatedBy?: string
	published?: {
		sourceHash: string
		fields: EnrichmentFields
		revision: number
		at: string
	}
	publication?: EnrichmentPublication
	supersededPublication?: {
		publication: EnrichmentPublication
		published?: NonNullable<EnrichmentRecord["published"]>
		supersededAt: string
		supersededBy: string
	}
}

export type EnrichmentPublication = {
	revision: number
	status: "pending" | "partial" | "complete"
	targets: Array<{
		collection: string
		id: string
		status: "pending" | "complete" | "failed"
		error?: string
	}>
}
